import { Icon, IconName, useSnackBar } from '@usealloy/component-library';
import { useContext, useMemo } from 'react';
import { UserContext } from '~/dashboard/context';
import { openSupport } from '~/helpers/supportWidget';

import { Sidebar } from '../component/Sidebar';
import { SupportWidgetPositionOverride } from './NavList.settings.styles';

/**
 * "Settings" nav group — Settings, Notifications, and Resources.
 *
 * Mirrors the FE2.0 SideNav `NavList.settings` structure. The Settings condition is
 * ported verbatim from the legacy sidebar; Notifications is new to the sidebar (FE2.0
 * parity — the Topbar bell remains) with its unread badge derived the same way as the
 * Topbar's `NotificationDropdown`; Resources ports the legacy dropdown.
 */
export const SettingsGroup = ({ expanded }: { expanded: boolean }) => {
  const { agent, featureFlags, intercom } = useContext(UserContext);

  const addSnackBar = useSnackBar();
  const isIntercomEnabled = useMemo(
    () => Boolean(featureFlags?.intercomMessengerChat),
    [featureFlags],
  );

  return (
    <Sidebar.Group style={{ marginTop: 'auto' }}>
      <SupportWidgetPositionOverride isSidebarCollapsed={!expanded} />

      <Sidebar.Menu>
        <Sidebar.MenuItem>
          <Sidebar.MenuButton
            data-dd-action-name="alloydd-sidebar-nav-support"
            {...(isIntercomEnabled ? { 'data-pendo-anchor': 'alloy-sidebar-nav-support' } : {})}
            tooltip="Support"
            onClick={() => {
              // UserContext's agent fields are optional; openSupport's Zendesk fallback
              // tolerates missing prefill data.
              type SupportAgent = Parameters<typeof openSupport>[0]['agent'];
              openSupport({
                agent: agent as SupportAgent,
                sidebarExpanded: expanded,
                intercomPositionOverride: { alignment: 'left', horizontal_padding: 20 },
                userJwt: intercom?.userJwt,
                onRateLimited: () => addSnackBar({
                  title: 'Something went wrong loading support. Please reload the page and try again.',
                  type: 'danger',
                }),
              });
            }}
          >
            <Icon icon={IconName.Question} />
            <span className="fs-unmask">Support</span>
          </Sidebar.MenuButton>
        </Sidebar.MenuItem>
      </Sidebar.Menu>
    </Sidebar.Group>
  );
};
